import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
import advancedFormat from 'dayjs/plugin/advancedFormat'

dayjs.extend(utc)
// 显示一年第n周的插件
dayjs.extend(weekOfYear)
// 提供更多格式化选择
dayjs.extend(advancedFormat)
// 显示一年第n个季度
dayjs.extend(quarterOfYear)
// 时区插件
dayjs.extend(timezone)
